import type { JobItem, JobType, JobStatus, PaginatedResponse } from "@/lib/api/types"

function sleep(ms: number) {
  return new Promise((r) => setTimeout(r, ms))
}

// V2-aligned mock data: CREATED/PROCESSING (not QUEUED/RUNNING), import/ingestion (not bulk_upload/vendor_ingestion)
const data: JobItem[] = [
  {
    id: "job_001",
    job_type: "import",
    status: "COMPLETED",
    attempt_count: 1,
    claimed_by: "worker-01",
    lease_expires_at: null,
    last_heartbeat_at: "2024-06-10T10:04:30Z",
    created_at: "2024-06-10T10:00:00Z",
  },
  {
    id: "job_002",
    job_type: "export",
    status: "PROCESSING",
    attempt_count: 1,
    claimed_by: "worker-02",
    lease_expires_at: "2024-06-15T12:30:00Z",
    last_heartbeat_at: "2024-06-15T12:25:00Z",
    created_at: "2024-06-15T12:00:00Z",
  },
  {
    id: "job_003",
    job_type: "metric_compute",
    status: "CREATED",
    attempt_count: 0,
    claimed_by: null,
    lease_expires_at: null,
    last_heartbeat_at: null,
    created_at: "2024-06-15T11:00:00Z",
  },
  {
    id: "job_004",
    job_type: "ingestion",
    status: "FAILED",
    attempt_count: 3,
    claimed_by: "worker-03",
    lease_expires_at: null,
    last_heartbeat_at: "2024-06-14T09:15:00Z",
    created_at: "2024-06-14T08:00:00Z",
  },
  {
    id: "job_005",
    job_type: "import",
    status: "PROCESSING",
    attempt_count: 2,
    claimed_by: "worker-01",
    lease_expires_at: "2024-06-15T13:00:00Z",
    last_heartbeat_at: "2024-06-15T12:55:00Z",
    created_at: "2024-06-15T10:30:00Z",
  },
  {
    id: "job_006",
    job_type: "other",
    status: "COMPLETED",
    attempt_count: 1,
    claimed_by: "worker-02",
    lease_expires_at: null,
    last_heartbeat_at: "2024-06-13T16:45:00Z",
    created_at: "2024-06-13T16:00:00Z",
  },
  {
    id: "job_007",
    job_type: "export",
    status: "CREATED",
    attempt_count: 0,
    claimed_by: null,
    lease_expires_at: null,
    last_heartbeat_at: null,
    created_at: "2024-06-15T12:10:00Z",
  },
  {
    id: "job_008",
    job_type: "metric_compute",
    status: "COMPLETED",
    attempt_count: 1,
    claimed_by: "worker-04",
    lease_expires_at: null,
    last_heartbeat_at: "2024-06-12T14:30:00Z",
    created_at: "2024-06-12T14:00:00Z",
  },
  {
    id: "job_009",
    job_type: "ingestion",
    status: "PROCESSING",
    attempt_count: 1,
    claimed_by: "worker-05",
    lease_expires_at: "2024-06-15T13:15:00Z",
    last_heartbeat_at: "2024-06-15T13:10:00Z",
    created_at: "2024-06-15T12:45:00Z",
  },
  {
    id: "job_010",
    job_type: "import",
    status: "FAILED",
    attempt_count: 2,
    claimed_by: "worker-01",
    lease_expires_at: null,
    last_heartbeat_at: "2024-06-11T11:20:00Z",
    created_at: "2024-06-11T10:00:00Z",
  },
]

export async function listJobs(params?: {
  page?: number
  page_size?: number
  type?: string
  status?: string
}): Promise<PaginatedResponse<JobItem>> {
  const page = params?.page ?? 1
  const page_size = params?.page_size ?? 25
  const typeFilter = params?.type
  const statusFilter = params?.status

  await sleep(200)

  let filtered = data

  if (typeFilter) {
    filtered = filtered.filter((j) => j.job_type === typeFilter)
  }

  if (statusFilter) {
    filtered = filtered.filter((j) => j.status === statusFilter)
  }

  return {
    items: filtered.slice((page - 1) * page_size, page * page_size),
    page,
    page_size,
    total: filtered.length,
  }
}

export const JOB_TYPES: JobType[] = [
  "import",
  "export",
  "metric_compute",
  "ingestion",
  "other",
]

export const JOB_STATUSES: JobStatus[] = ["CREATED", "PROCESSING", "COMPLETED", "FAILED"]
